<template>
  <component :is="currentView" />
</template>

<script>
import Home from "@/views/home/map/View.vue";
import Home2 from "@/views/home/home2/Home2.vue";

export default {
  components: { Home, Home2 },
  computed: {
    currentView() {
      const view = this.$route.query.view;
      return view === "fleet" ? "Home2" : "Home";
    }
  }
};
</script>
